export const VUE_ROUTER = 'VUE_ROUTER';
export const SALES_INTEL_BASE_PATH = '/sales-intel';
export const COPILOT_BASE_PATH = '/copilot-view';
